module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/~/core-js/modules/_an-instance.js
// module id = ../../../../core-js/modules/_an-instance.js
// module chunks = 6